package org.tlsys

object AnimationSpeed {
    val LAYOUT_CHANGE = 50
    val HIDE_DIALOG = LAYOUT_CHANGE
    val SHOW_DIALOG = LAYOUT_CHANGE
}
